import type { WhitelistItem as WhitelistItemType } from "@gearbox-protocol/cli-utils";
import { Button, NetworkLogo, Trash } from "@gearbox-protocol/deploy-tools-ui";
import { formatDistanceToNow } from "date-fns";
import type { FC } from "react";

interface WhitelistListItemProps {
  item: WhitelistItemType;
  onDelete?: (item: WhitelistItemType) => void;
}

export const WhitelistListItem: FC<WhitelistListItemProps> = ({
  item,
  onDelete,
}) => {
  const { network, address, contractType, reason, expiresAt } = item;

  return (
    <tr>
      <td>
        <NetworkLogo network={network} />
      </td>
      <td className="px-2">
        <pre>{address}</pre>
      </td>
      <td className="whitespace-nowrap px-2">{contractType ?? ""}</td>
      <td className="w-full">{reason}</td>
      <td className="whitespace-nowrap">
        {expiresAt
          ? formatDistanceToNow(expiresAt, { addSuffix: true })
          : "Never"}
      </td>
      {!!onDelete && (
        <td>
          <Button
            variant="ghost"
            size="icon"
            role="button"
            onClick={() => onDelete(item)}
          >
            <Trash />
          </Button>
        </td>
      )}
    </tr>
  );
};
